import React from 'react';
import { DateInput, useTranslate } from 'react-admin';
import { Box } from '@material-ui/core';
import '../../avatarAnc/filters/PeriodInputInstallationDate.css';

/**
 * after/before pair for any v2 timestamp column. The `__after` / `__before` suffixes are what the
 * data provider turns into API Platform's `[after]` / `[before]` date filter parameters.
 */
const PeriodInputV2 = (props: { source: string; label: string; alwaysOn?: boolean }) => {
    const translate = useTranslate();

    return (
        <Box className='period-filter'>
            <DateInput
                size={'medium'}
                {...props}
                label={`${props.label} — ${translate('app.common.after')}`}
                variant={'standard'}
                source={`${props.source}__after`}
            />

            <DateInput
                size={'medium'}
                {...props}
                variant={'standard'}
                label={`${props.label} — ${translate('app.common.before')}`}
                source={`${props.source}__before`}
            />
        </Box>
    );
};

export default PeriodInputV2;
